import type { ReactNode } from 'react';
import { useModuleLicense } from '../../hooks/useModuleLicense';
import { SeatRequired } from '../nursery/accounts/AccountBits';

/**
 * For the few accounts pages the nursery still reads. Customers and price
 * lists are set up with an Accounts seat, but an order is taken for a customer
 * at a price, so the nursery seats named here see the page too. What they can
 * change is decided inside the page, and again by the server.
 */
export default function AccountsOrNurseryGate({ nursery, retail = [], what, children }: {
  nursery: string[];
  /** Retail seats that also open the page: a retail nursery's shop. */
  retail?: string[];
  what: string;
  children: ReactNode;
}) {
  const accounts = useModuleLicense('accounts', ['user', 'admin']);
  const grower = useModuleLicense('nursery', nursery);
  const shop = useModuleLicense('retail', retail);

  if (accounts.loading || grower.loading || shop.loading) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="h-8 bg-neutral-100 rounded animate-pulse w-64 mb-4" />
        <div className="h-40 bg-neutral-100 rounded animate-pulse" />
      </div>
    );
  }
  if (!accounts.hasAccess && !grower.hasAccess && !shop.hasAccess) return <SeatRequired seat="user" what={what} />;
  return <>{children}</>;
}
